export { default as getSelectedNameSlot } from "./getSelectedNameSlot";
